// Con la configuración en tiempo de ejecución (/config.js por APR), un mismo
// build puede servir a cualquier APR y un origen puede pasar de un APR a otro
// sin rebuild. Eso significa que la identidad del tenant (el `eid`) puede
// cambiar en un navegador que ya tenía sesión/datos biométricos guardados
// del APR anterior. Antes (build por APR) esto no era posible: cambiar de
// APR exigía un rebuild y por lo tanto un origen nuevo. Este guard detecta
// el cambio de `eid` y purga lo que quedó del tenant anterior antes de que
// la app termine de arrancar.
//
// La validez del `eid` en sí sigue siendo responsabilidad del API (viaja en
// cada request y un token de otro tenant recibe 401); este guard solo evita
// que quede basura de sesión/biometría del APR anterior en el navegador.

const EID_KEY = 'apr_eid';
const BIOMETRIC_KEYS = ['biometric_enabled', 'biometric_device_id', 'biometric_prompt_shown'];

export default function tenantGuard(config) {
    try {
        const previousEid = localStorage.getItem(EID_KEY);

        if (previousEid && previousEid !== config.aprEid) {
            sessionStorage.clear();
            BIOMETRIC_KEYS.forEach((key) => localStorage.removeItem(key));
        }

        localStorage.setItem(EID_KEY, config.aprEid);
    } catch (err) {
        // Si el storage no está disponible (ventana privada, sitio bloqueado,
        // contexto de preview/thumbnail), no debe impedir que la app arranque.
    }
}
